import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const MockupRoute = (props) => {
    const token = localStorage.getItem('token');
    return token ? <Route {...props} /> : <Redirect to="/auth/login" />;
};

export default MockupRoute;
